import { graphql, useStaticQuery } from "gatsby";
import { AboutIntroductionQuery } from "./query.generated";

export type CMSIntroductionData = AboutIntroductionQuery["cms"];

export function useStaticIntroductionQuery(): CMSIntroductionData {
  const data = useStaticQuery<AboutIntroductionQuery>(
    graphql`
      query AboutIntroduction {
        cms {
          site(hostname: "www.italymondo.com") {
            aboutPage: pages(contentType: "italymondo_about.IMAboutPage") {
              ... on CMS_IMAboutPage {
                introMedia {
                  ... on CMS_MediaImagesBlock {
                    __typename
                    images {
                      image {
                        alt
                        url
                        urlSharp {
                          childImageSharp {
                            gatsbyImageData(
                              placeholder: BLURRED
                              width: 950
                              height: 650
                            )
                          }
                        }
                      }
                    }
                  }
                  ... on CMS_TestimonialsBlock {
                    __typename
                    testimonials {
                      testimonial {
                        date
                        longMessage
                        name
                        photo {
                          alt
                          url
                          urlSharp {
                            childImageSharp {
                              gatsbyImageData(
                                height: 60
                                width: 60
                                placeholder: BLURRED
                              )
                            }
                          }
                        }
                        sourceDetail {
                          logo {
                            title
                            url
                          }
                          url
                        }
                      }
                    }
                  }
                }
                introMediaPlacement
                introParagraph
                introShadowHeader
              }
            }
          }
        }
      }
    `
  );
  return data.cms;
}
